// Generated by ReScript, PLEASE EDIT WITH CARE

import * as PartnerContentHelper from "./PartnerContentHelper.bs.js";

function getContent(message_text, vehicle_category, geo_region) {
  vehicle_category !== 0;
  return {
          title_text: "कैंसलेशन स्कोर",
          learn_more_text: "अधिक जाणून घ्या",
          info_btn_details: {
            video_url: undefined,
            question: "कैंसलेशन स्कोर कसा मोजला जातो?",
            answer: "तुम्ही स्वीकारलेल्या शेवटच्या 30 ऑर्डरमध्ये ड्रायव्हरला दिलेल्या कैंसलेशनच्या एकूण संख्येवर आधारित कॅन्सलेशन स्कोरची गणना केली जाते."
          },
          learn_more_btn_details: [
            {
              video_url: PartnerContentHelper.getV2LearnMoreVid(geo_region),
              question: "कैंसलेशन स्कोर म्हणजे काय आणि ते महत्त्वाचे का आहे?",
              answer: ""
            },
            {
              video_url: undefined,
              question: "मला कधी निलंबित केले जाईल?",
              answer: "जेव्हा तुम्ही पातळी ओलांडता तेव्हा तुम्हाला संबंधित कालावधीसाठी निलंबित केले जाईल."
            },
            {
              video_url: undefined,
              question: "प्रत्येक स्तरासाठी निलंबन कालावधी किती आहे?",
              answer: "प्रत्येक स्तरावरील निलंबनाचा कालावधी निलंबन मार्गदर्शकामध्ये तपासला जाऊ शकतो."
            },
            {
              video_url: undefined,
              question: "मी कैंसलेशन स्कोर का पाहू शकत नाही?",
              answer: "अलिकडच्या महिन्यांत किमान 30 ऑर्डर स्वीकारलेल्या भागीदारांसाठी कैंसलेशन स्कोर मोजला जातो."
            }
          ],
          locked_score_msg: "कैंसलेशन स्कोर अनलॉक करण्यासाठी अधिक ऑर्डर स्वीकारा.",
          message_text: message_text,
          suspension_guide_text: "सस्पेंशन गाइड",
          suspension_guide_table_details: {
            cancellation_score_text: "कैंसलेशन स्कोर",
            suspension_days_text: "निलंबन दिवस"
          }
        };
}

export {
  getContent ,
  
}
/* No side effect */
